// This file only loads the files into webpack as an alternative to application.js

import './app/namespace';

import './app/views/components/actionsDropdown';
import './app/views/components/confirmationModal';
import './app/views/components/confirmationDialog';
import './app/views/components/informationModal';
import './app/views/components/dynamicGroupForm';
import './app/views/components/templateNameGenerator';
import './app/views/components/rje/codes';
import './app/views/components/rje/api/configuration';
import './app/views/components/rje/api/management';
import './app/views/components/rje/api/state_actions';
import './app/views/components/rje/api/state_poll';
import './app/views/components/rje/widgets/configuration';
import './app/views/components/rje/widgets/management';
import './app/views/components/rje/widgets/modal_summary';
import './app/views/components/rje/widgets/state_actions';
import './app/views/components/form_fields/internet_address';
import './app/views/components/form_fields/ip';
import './app/views/components/form_fields/simple';

import './app/views/content/footer/confirmation_modal';
import './app/views/header';
import './app/views/sidebar';
import './app/views/table';
import './app/views/content/payment_device_types/index';
import './app/views/content/payment_device_types/new';
import './app/views/content/payment_device_types/show';
import './app/views/content/payment_device_types/affected_payment_devices';
import './app/views/content/payment_device_types/destroy';
import './app/views/content/two_factor_auths/index';
import './app/views/content/two_factor_auths/new';
import './app/views/content/two_factor_auths/show';
import './app/views/content/payment_devices/new';
import './app/views/content/payment_devices/details';
import './app/views/content/payment_devices/index';
import './app/views/content/payment_devices/show';
import './app/views/content/payment_server_config/view';
import './app/views/content/imports/index';
import './app/views/content/virtual_nodes/new';
import './app/views/content/virtual_nodes/index';
import './app/views/content/swagger/index';
import './app/views/content/servers/index';
import './app/views/content/servers/new';
import './app/views/content/servers/show';
import './app/views/content/nodes/index';
import './app/views/content/nodes/new';
import './app/views/content/nodes/show';
import './app/views/content/user_groups/index';
import './app/views/content/user_groups/show';
import './app/views/content/user_groups/new';
import './app/views/content/users/new';
import './app/views/content/users/shell_user';
import './app/views/content/users/show';
import './app/views/content/node_groups/puppet_module_changes_modal';
import './app/views/content/node_groups/new';
import './app/views/content/node_groups/index';
import './app/views/content/node_groups/show';
import './app/views/content/node_groups/configure';
import './app/views/content/node_groups/export';
import './app/views/content/properties/index';
import './app/views/content/node_group_roles/show';
import './app/views/content/customers/new';
import './app/views/content/customers/show';
import './app/views/content/ownership_transfers/new';
import './app/views/content/icc_policies/new';
import './app/views/content/icc_policies/show';
import './app/views/content/icc_policies/index';
import './app/views/content/icc_policies/impacted_icc_resources';
import './app/views/content/firewall/rules/new';
import './app/views/content/firewall/rules/index';
import './app/views/content/firewall/rules/show';
import './app/views/content/firewall/policies/index';
import './app/views/content/firewall/policies/new';
import './app/views/content/firewall/policies/show';
import './app/views/content/locations/index';
import './app/views/content/locations/edit';
import './app/views/content/locations/new';
import './app/views/content/locations/show';
import './app/views/content/puppet_profiles/index';
import './app/views/content/puppet_profiles/new';
import './app/views/content/packages/show';
import './app/views/content/packages/clone';
import './app/views/content/packages/new';
import './app/views/content/preference/edit';
import './app/views/content/preference/new';
import './app/views/content/preference/management_changes_modal';
import './app/views/content/hierarchy_definitions/new';
import './app/views/content/hierarchy_definitions/index';
